<template>
    <div class="cont">
        <div class="bgcBox flex flex-direction">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto"
                     class="ruleForm" v-loading="loading">
                <el-form-item ref="phone" label="联系电话" prop="phone" class="input-container">
                    <el-input v-model="ruleForm.phone" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item ref="content" label="反馈内容" prop="content" class="input-container">
                    <el-input v-model="ruleForm.content" placeholder="请输入"
                              type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" resize="none"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="input-form-btn margin-tb-sm padding-lr self-center" type="warning"
                       @click="submitForm('ruleForm')" :loading="submit_loading">
                提交反馈
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "feedback",
    data() {
        return {
            ruleForm: {
                phone: '',//
                content: '',//
            },
            rules: {
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'},
                    {required: true, pattern: /^1[0-9]{10}$/, message: '手机号码不正确', trigger: 'onChange'}
                ],
                content: [
                    {required: true, message: '请输入反馈内容', trigger: 'blur'},
                ]
            },
            loading: false,
            submit_loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (!this.user) {
            this.$router.push("/login")
        }
        this.$emit('setIsAct', 10)
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitChange();
                } else {
                    return false;
                }
            });
        },
        async submitChange() {
            this.submit_loading = true
            this.$api.apiContent.feedback({
                phone: this.ruleForm.phone,
                content: this.ruleForm.content,
                source: 4
            }).then(() => {
                this.submit_loading = false
                this.$message.success('提交成功')
                this.$refs.ruleForm.resetFields()
            }).catch(e => {
                this.submit_loading = false
                this.$message.error(e.info)
            })
        }
    },
    components: {},

}
</script>

<style scoped lang="scss">
.bgc {
    background: url("../../../assets/images/xian.png") no-repeat bottom center !important;
    color: #0a2240 !important;
}
::v-deep{
    .el-form-item__label{
        color: #0a2240!important;
    }
}

.cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;

    .navTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-size: 14px;
    }

    .bgcBox {
        width: 100%;
        min-height: 800px;
        background-color: #fff;
        padding: 20px;
    }
    .input-form-btn{
        width: 200px;
    }
}

</style>
